import { useLang } from "../context/LanguageContext";
import { useAIAssistant } from "../context/AIAssistantContext";

export const FloatingAIButton = () => {
  const { t } = useLang();
  const { openAssistant, open } = useAIAssistant();

  if (open) return null;

  return (
    <button
      data-testid="floating-ai-button"
      onClick={openAssistant}
      aria-label={t.floatingAI.label}
      className="group fixed bottom-20 right-5 sm:bottom-24 z-40 inline-flex items-center gap-2 pl-2 pr-4 sm:pr-5 py-2 rounded-full bg-[#0f0f12] border border-[#FF5A00]/40 shadow-[0_10px_40px_-10px_rgba(255,90,0,0.55)] hover:shadow-[0_18px_60px_-12px_rgba(255,90,0,0.8)] hover:border-[#FF5A00]/70 transition-all"
    >
      <span className="relative inline-flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-[#FF5A00] to-[#c74400] text-white">
        <i className="fa-solid fa-wand-magic-sparkles text-base" />
        <span className="absolute inset-0 rounded-full fk-pulse-glow" />
      </span>
      <span className="hidden sm:inline text-sm font-medium text-white whitespace-nowrap">
        {t.floatingAI.label}
      </span>
      <span className="sm:hidden text-xs font-medium text-white whitespace-nowrap">
        {t.floatingAI.short}
      </span>
    </button>
  );
};
